(function () {
  'use strict';
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  const open = (p) => { p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false'); };
  const close = (p) => { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); };
  const inEditor = () => window.Shopify && window.Shopify.designMode;

  function init(root = document) {
    root.querySelectorAll('[data-popup]').forEach((p) => {
      if (p._init) return;
      p._init = true;
      const key = 'popup:' + p.dataset.popup;
      const isAge = p.hasAttribute('data-age-gate');
      const reminder = document.querySelector('[data-popup-reminder="' + p.dataset.popup + '"]');
      const remKey = key + ':reminder-off';
      const showReminder = () => { if (reminder && !store.get(remKey)) reminder.hidden = false; };
      if (reminder && !reminder._init) {
        reminder._init = true;
        reminder.addEventListener('click', (e) => {
          if (e.target.closest('[data-reminder-close]')) { reminder.hidden = true; store.set(remKey, '1'); return; }
          reminder.hidden = true;
          open(p);
        });
      }
      p.addEventListener('click', (e) => {
        if (e.target.closest('[data-popup-close]')) {
          close(p);
          if (!isAge) { store.set(key, Date.now()); showReminder(); }
        }
        if (e.target.closest('[data-age-confirm]')) {
          store.set(key, 'ok');
          close(p);
        }
      });
      if (inEditor() || p.dataset.enabled !== 'true') return;
      if (isAge) {
        if (store.get(key) !== 'ok') open(p);
        return;
      }
      if (p.querySelector('[data-popup-success]')) { open(p); store.set(key, Date.now()); return; }
      const last = parseInt(store.get(key) || '0', 10);
      const days = parseInt(p.dataset.frequency || '7', 10);
      if (Date.now() - last < days * 86400000) { showReminder(); return; }
      setTimeout(() => open(p), (parseInt(p.dataset.delay || '8', 10)) * 1000);
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') document.querySelectorAll('[data-popup].is-open:not([data-age-gate])').forEach(close);
  });
  // Theme editor: show popup while its section is selected
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => { const p = e.target.querySelector('[data-popup]'); if (p) open(p); });
  document.addEventListener('shopify:section:deselect', (e) => { const p = e.target.querySelector('[data-popup]'); if (p) close(p); });
})();
